// src/features/tasks/components/TaskListPage/TasksDataGrid/components/ActionsCell.jsx
import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { getAvailableTransitions } from '../../../../utils/taskStateUtils';
import TaskActionButtons from '../../../TaskActionButtons';

export default function ActionsCell({
  row,
  canUpdate,
  canDelete,
  canChangeState,
  onView,
  onEdit,
  onDelete,
  onStateChange,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation(); // Prevent row click
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action, event) => {
    event?.stopPropagation(); // Prevent row click
    handleClose();
    action();
  };

  // Get available state transitions for menu
  const availableTransitions = canChangeState && row.state !== 'SCHEDULED'
    ? getAvailableTransitions(row)
    : [];

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      {/* Quick State Action Buttons */}
      {row.state !== 'SCHEDULED' && (
        <TaskActionButtons
          task={row}
          onStateChange={onStateChange}
          variant="icons"
          size="small"
          maxVisibleButtons={1}
        />
      )}

      {/* Three-dot menu for standard actions */}
      {canDelete && (
        <>
          <IconButton
            size="small"
            onClick={handleClick}
            sx={{ p: 0.5 }}
            aria-label="More actions"
            aria-controls={open ? 'task-actions-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <MoreVertIcon fontSize="medium" />
          </IconButton>

          <Menu
            id="task-actions-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'task-actions-button',
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            PaperProps={{
              sx: {
                minWidth: 160,
                boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
              }
            }}
          >
            {canDelete && [
              <MenuItem 
                key="delete"
                onClick={(e) => handleMenuItemClick(() => onDelete(row), e)}
                sx={{ 
                  color: 'error.main',
                  '&:hover': {
                    backgroundColor: 'error.50',
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <DeleteIcon fontSize="small" color="error" />
                </ListItemIcon>
                <ListItemText primary="Delete" />
              </MenuItem>
            ]}
          </Menu>
        </>
      )}
    </Box>
  );
}